export class Form {
    constructor(message) {
        this.message = message;
    }

    schema() {
        return [
            {
                'component': 'h2',
                'children': this.message,
            },
            {
                'component': 'div',
                'class': 'row',
                'children': [
                    {
                        'type': 'text',
                        'name': 'headline',
                        'label': 'Überschrift',
                        'class': 'col-12 col-md-8',
                        'placeholder': 'Bitte Überschrift eingeben...',
                        'validation': 'min:5,length|required',
                        'validation-name': 'Name',
                    },
                    {
                        'type': 'number',
                        'name': 'price',
                        'label': 'Preis',
                        'class': 'col-12 col-md-4',
                        'placeholer': 'Bitte Preis einfügen ...',
                        'validation': 'optional|number',
                        'validation-name': 'Preis',
                        'step': 0.01,
                    },
                    {
                        'type': 'date',
                        'name': 'date_from',
                        'label': 'Gültig ab',
                        'class': 'col-12 col-md-6',
                        'placeholer': 'Angebot gültig ab ...',
                        'validation': 'required|date',
                        'validation-name': 'Sichtbarkeit von ',
                    },
                    {
                        'type': 'date',
                        'name': 'date_to',
                        'label': 'Gültig bis',
                        'class': 'col-12 col-md-6',
                        'placeholer': 'Angebot gültig bis ...',
                        'validation': 'optional|date',
                        'validation-name': 'Sichtbarkeit bis ',
                        'help': 'Wenn Ihre Aktion nur an einem Tag gültig ist, können Sie dieses Feld leer lassen.',
                    },
                    {
                        'type': 'editor',
                        'name': 'description',
                        'label': 'Beschreibung',
                        'class': 'col-12',
                        'placeholder': 'Beschreibung ...',
                        'validation': 'required|min:10,length',
                        'validation-name': 'Beschreibung',
                    },
                    {
                        'type': 'date',
                        'name': 'visible_from',
                        'label': 'Sichtbar ab',
                        'class': 'col-12 col-md-6',
                        'placeholder': 'Angebot sichtbar ab ...',
                        'validation': 'optional|date',
                        'help': 'Hier können Sie festlegen ab welchem Tag der Eintrag sichtbar ist. Ist das Feld leer, dann wird das Angebot sofort dargestellt.',
                    },
                    {
                        'type': 'date',
                        'name': 'visible_to',
                        'label': 'Sichtbar bis',
                        'class': 'col-12 col-md-6',
                        'validation': 'optional|date',
                        'validation-name': 'Beschreibung',
                        'placeholder': 'Angebot sichtbar bis ...',
                        'help': 'Ist das Feld leer, dann bleibt das Angebot bis zum Ende des Aktionszeitraum online.',
                    },
                ],
            },
        ];

    }
}
